export enum CaseModuleRoutes {
    QUICK_PROCESSING = 'case/:id/quick-processing',
    DETAILED_PROCESSING = 'case/:id/details',

    ACCIDENT_DESCRIPTION = 'accident-description',
    ACCIDENT_OPPONENT = 'accident-opponent',
    ATTACHMENTS = 'attachments',
    DISTRIBUTION = 'distribution',
    GENERAL = 'general',
    LAWYER = 'lawyer',
    PARTICIPANTS = 'participants',
    RESULTS = 'results',
    SUMMARY = 'summary',
    VEHICLE = 'vehicle'
}
